module.exports = __webpack_public_path__ + "img/luckdraw_start.d3e78499.png";